// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export enum FormatType {
  "yyyy-MM-dd hh:mm:ss" = "yyyy-MM-dd hh:mm:ss",
  "YYYY/MM/DD HH:mm" = "YYYY/MM/DD HH:mm",
  "yyyy-MM-dd" = "yyyy-MM-dd",
  "YYYY/MM/DD" = "YYYY/MM/DD",
  "HH:mm" = "HH:mm",
  "YYYY年M月D日" = "YYYY年M月D日",
  "YYYY/M/D" = "YYYY/M/D",
  "YYYY/MM/DD HH:mm:ss" = "YYYY/MM/DD HH:mm:ss",
}

export default FormatType;
